import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import {
  ArrowRight, FileCheck2, BookOpenCheck, ShieldCheck, Layers, ClipboardCheck,
  SearchCheck, Wrench, CalendarCheck, FileText,
} from "lucide-react";
import { services } from "../mock";

const iconMap = {
  FileCheck2, BookOpenCheck, ShieldCheck, LayersIcon: Layers, ClipboardCheck,
  SearchCheck, Wrench, CalendarCheck,
};

export default function Services() {
  return (
    <main>
      <PageHero
        eyebrow="Services"
        title="NDIS Compliance Support Across Every Stage of Your Provider Journey"
        subtitle="From registration preparation to ongoing compliance, we deliver audit informed support tailored to your registration groups, modules and service scope."
        breadcrumb={[{ label: "Services" }]}
      />

      <section className="py-20">
        <div className="container-x">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s) => {
              const Icon = iconMap[s.icon] || FileText;
              return (
                <Link key={s.slug} to={`/services/${s.slug}`} className="group card-soft bg-white rounded-2xl p-7 md:p-8 border border-slate-200 flex flex-col">
                  <div className="w-14 h-14 rounded-xl bg-teal-soft text-teal flex items-center justify-center mb-6 group-hover:bg-teal group-hover:text-white transition">
                    <Icon size={24} />
                  </div>
                  <h3 className="text-navy font-bold text-[18.5px] leading-snug">{s.title}</h3>
                  <p className="mt-3 text-[15px] text-slate-600 leading-[1.7] flex-1">{s.short}</p>
                  <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-teal group-hover:gap-2.5 transition-all">
                    Learn more <ArrowRight size={15} />
                  </span>
                </Link>
              );
            })}
          </div>

          <div className="mt-12 p-6 bg-mist rounded-2xl border-l-4 border-teal">
            <p className="text-sm text-slate-700 leading-relaxed">
              <strong className="text-navy">Compliance note.</strong> Our consultancy services are separate from
              independent Approved Quality Auditor services. We support providers to prepare for audit, but we do
              not act as the independent external Approved Quality Auditor for providers we have consulted to.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
